module.exports = __webpack_public_path__ + "img/catalog-categories.0f29400a.png";